import type { ResponseType } from '../types/responses';
import type { PdfConfirmRequest, PdfConfirmResult } from '../types/pdfPreview';
import { apiClient } from './apiClient';

export const pdfConfirmProvider = {
  confirm: (
    previewId: string,
    request: PdfConfirmRequest,
    idempotencyKey: string
  ): Promise<ResponseType<PdfConfirmResult>> =>
    apiClient<PdfConfirmResult>(
      `/ai-listing/pdf-previews/${encodeURIComponent(previewId)}/confirm`,
      'POST',
      request,
      { headers: { 'Idempotency-Key': idempotencyKey } }
    ),

  lookupPdfConfirm: (
    previewId: string,
    idempotencyKey: string
  ): Promise<ResponseType<PdfConfirmResult>> =>
    apiClient<PdfConfirmResult>(
      `/ai-listing/pdf-previews/${encodeURIComponent(previewId)}/confirm`,
      'GET',
      null,
      { headers: { 'Idempotency-Key': idempotencyKey } }
    ),

  getStatus: (confirmId: string): Promise<ResponseType<PdfConfirmResult>> =>
    apiClient<PdfConfirmResult>(`/ai-listing/pdf-confirms/${encodeURIComponent(confirmId)}`, 'GET'),
};
